import { render, staticRenderFns } from "./TheFraisTransportTypeAdministrateur.vue?vue&type=template&id=60e46d7e&"
import script from "./TheFraisTransportTypeAdministrateur.vue?vue&type=script&lang=js&"
export * from "./TheFraisTransportTypeAdministrateur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheFraisTransportTypeAdministrateur.vue"
export default component.exports